import React from "react";
import './index.scss';

export const Divider = () => {
	return <div className="app-section-divider"/>
};
